"use strict";

module.exports = require("lodash/escapeRegExp");